import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAudio } from '../context/AudioContext';
import './FloatingTtsControl.css';
import { useI18n } from '../i18n';

export default function FloatingTtsControl() {
  const audio = useAudio();
  const { t } = useI18n();
  const active = !!audio?.isSpeaking;

  return (
    <AnimatePresence>
      {active && (
        <motion.button
          type="button"
          className={`floating-tts-control ${audio?.isSpeechPaused ? 'paused' : 'playing'}`}
          aria-label={audio?.isSpeechPaused ? t('audio.resumeAgent') : t('audio.pauseAgent')}
          title={audio?.isSpeechPaused ? t('common.resume') : t('common.pause')}
          onClick={audio?.toggleSpeech}
          initial={{ opacity: 0, scale: 0.5, y: 18 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 18 }}
          transition={{
            opacity: { duration: 0.2 },
            y: { duration: 0.25 },
            scale: { duration: 0.18 },
          }}
        >
          <span className="floating-tts-control__core">
            {audio?.isSpeechPaused ? '▶' : 'Ⅱ'}
          </span>
          <span className="floating-tts-control__halo" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
